$(document).ready(function() {
    $('html, body').css('overflow-y', 'visible');
    let timer7;
    let total7 = $("#home-section-7 .owl-carousel .item").length;
    $('#home-section-7 .bar-page .page').html('01/' + twoDigits(total7));
    $('#home-section-7 .bar-page .bar .span').width((100/total7)+'%');

    let slider7 = $("#home-section-7 .owl-carousel").owlCarousel({
        items: 3,
        slideBy: 1,
        dots: false,
        nav: true,
        loop: true,
        center: true,
        autoplay: true,
        autoplayTimeout: 5000,
        touchDrag: false,
        mouseDrag: false,
        smartSpeed: 300,
        navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
        responsive: {
            0 : {
                items: 1,
                margin: 20,
            },
            360 : {
                items: 1,
                margin: 20,
            },
            375 : {
                items: 1,
                margin: 20,
            },
            390 : {
                items: 1,
                margin: 20,
            },
            414 : {
                items: 1,
                margin: 20,
            },
            428 : {
                items: 1,
                margin: 20,
            },
            480 : {
                items: 1,
                margin: 20,
            },
            768 : {
                items: 1,
                margin: 30,
            },
            800 : {
                items: 1,
                margin: 30,
            },
            1024 : {
                items: 3,
                margin: 0,
            },
            1280 : {
                items: 3,
                margin: 0,
            },
            1366 : {
                items: 3,
                margin: 0,
            },
            1440 : {
                items: 3,
                margin: 0,
            },
            1536 : {
                items: 3,
                margin: 0,
            },
            1600 : {
                items: 3,
                margin: 0,
            },
            1920 : {
                items: 3,
                margin: 0,
            },
            2560 : {
                items: 3,
                margin: 0,
            },
        }
    }).on('changed.owl.carousel', function(event) {
        clearTimeout(timer7);
        timer7 = setTimeout(function(){
            let page = $(event.target).find('.owl-item.center .item').data('slide');
            $('#home-section-7 .bar-page .bar .span').width(((100/total7)*page)+'%');
            $('#home-section-7 .bar-page .page').html(twoDigits(page) + '/' + twoDigits(total7))
        }, 50);
    });
  
    let slider8 = $("#home-section-8 .owl-carousel").owlCarousel({
        items: 2,
        dots: false,
        nav: true,
        loop: false,
        smartSpeed: 500,
        stagePadding: 150,
        margin: 50,
        navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
        responsive: {
            0 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            360 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            375 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            390 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            414 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            428 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            480 : {
                items: 1,
                stagePadding: 50,
                margin: 20,
            },
            768 : {
                items: 2,
                stagePadding: 50,
                margin: 30,
            },
            800 : {
                items: 2,
                stagePadding: 50,
                margin: 30,
            },
            1024 : {
                items: 2,
                stagePadding: 50,
                margin: 30,
            },
            1280 : {
                items: 2,
                stagePadding: 100,
                margin: 40,
            },
            1366 : {
                items: 2,
                stagePadding: 100,
                margin: 40,
            },
            1440 : {
                items: 2,
                stagePadding: 130,
                margin: 50,
            },
            1536 : {
                items: 2,
                stagePadding: 130,
                margin: 50,
            },
            1600 : {
                items: 2,
                stagePadding: 150,
                margin: 50,
            },
            1920 : {
                items: 2,
                stagePadding: 150,
                margin: 50,
            },
            2560 : {
                items: 2,
                stagePadding: 150,
                margin: 50,
            },
        }
    });
  
    polygon3();

});

$(window).scroll(function() {
    showAddToCart();

    polygon3();
});



var $section3 = $('#product-ebike-section-3');
function polygon3() {
    if (!$section3.length) return;
    let clipValue = calculatePolygon5($section3);

    let clip15 = 15 - clipValue[0];
    let clip85 = ((85 / clipValue[1])*100);

    $section3.css('clip-path', `polygon(${clip15}% 0, ${clip85}% 0, ${clip85}% 100%, ${clip15}% 100%)`);
}

$('#home-section-8 .owl-carousel img').on('mouseover', function() {
    if (wSize >= 1280) {
        $('#home-section-8 .owl-carousel img').css('border-radius', '0');
        $(this).css('border-radius', '50%');
    }
}).on('mouseleave', function() {
    if (wSize >= 1280) {
        $(this).css('border-radius', '0');
    }
});



function twoDigits(num) {
    return num < 10 ? "0" + num : num;
}
